module.exports = __webpack_public_path__ + "img/chess-searchbg5.6f2246a5.jpg";